import Conf from '../../loader/Conf'

export default class DataLayer {
  static push (data = {}) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }

  static synchronizeUserData () {
    const contact = Conf.get()?.userContactDetails ?? {
      firstname: '',
      lastname: '',
      email: '',
      phone: ''
    }

    let o = {}

    for (let key in contact) {
      if (contact[key].length) {
        o[`noci:user:${key}`] = contact[key]
      }
    }

    if (Object.keys(o).length) DataLayer.push(o)
  }
}
